<template>
  <div class="tPassDirections">
    <div class="footer-item p-4" :class="bgColor">
      <p>{{ title }}</p>
      <ul>
        <li v-for="(item, index) in content" :key="index">
          {{ item.text }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TPassDirections',

  props: {
    title: {
      type: String,
      default: '電子收據歸戶說明',
    },
    content: {
      type: Array,
      default: () => [],
    },
    bgColor: {
      type: String,
      default: 'bg-light-gray-2',
    },
  },

  data() {
    return {
      messageIcon: '',
      alertColor: '',
      msg: '',
      subMsg: '',
      isShowSubMsg: false,
      btnName: '',
      btnColor: 'blue',
      isShowBtn: false,
      apiLoading: false,
    };
  },
  methods: {
    changeMsgIcon(type = 'info', message, subMessage, title, options) {
      console.log('type-', type);
      console.log(' message, subMessage, title, options', message, subMessage, title, options);
      switch (type) {
        case 'success':
          this.messageIcon = 'fa-check';
          break;
        case 'warning':
          this.messageIcon = 'fa-exclamation';
          break;
        case 'error':
          this.messageIcon = 'fa-times';
          break;
        case 'info':
          this.messageIcon = 'fa-info';
          break;
        default:
          this.messageIcon = 'fa-info';
          break;
      }
      this.alertColor = `modal-alert-white-${type}`;
      this.msg = message;
      this.subMsg = subMessage;
      if (subMessage !== '') {
        this.isShowSubMsg = true;
      } else {
        this.isShowSubMsg = false;
      }
      this.title = title;
      if (options && options.isShowBtn === true) {
        this.btnName = options.btnName;
        this.isShowBtn = options.isShowBtn;
        // this.btnColor = `${type}-2`;
      }
    },
    clickBtn() {
      console.log('觸發');
      this.$emit('openTPassDetailContent', this.TPassdetailData, 'msgGoBack');
    },
  },
};
</script>
